module.exports = __webpack_public_path__ + "static/media/generated_products.504adff4.txt";